/* eslint-disable */

document.addEventListener('alpine:init', () => {
    Alpine.data('heroVideo', () => ({
        video: null,
        isPlaying: true,
        deviceType: "desktop",
        init() {
            this.setPlayToggle();
            this.resizeEvent();
        },
        resizeEvent() {
            this.deviceType = this.getDeviceType();

            window.addEventListener('resize', () => {
                this.$nextTick(() => {
                this.deviceType = this.getDeviceType();
                });
            });
        },
        isDesktopSize() {
            return this.$breakpointIs('lg');
        },
        isTabletSize() {
            return this.$breakpointIs('md');
        },
        isMobileSize() {
            return !this.isDesktopSize() && !this.isTabletSize();
        },
        getDeviceType() {
            const ua = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                return "tablet";
            }
            if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                return "mobile";
            }
            return "desktop";
        },
        setPlayToggle() {
            const videoButton = this.$el.querySelector('.videoButton button');
            const triggerEvents = ['click', 'touchstart'];

            const setEvent = (evt) => {
                videoButton.addEventListener(evt, () => {
                let videoDisplay;
                const desktopVideoEl = this.$el.querySelector('.desktopVideo');
                const mobileVideoEl = this.$el.querySelector('.mobileVideo') ?? desktopVideoEl;
                if (this.getDeviceType() === 'desktop') {
                    if (this.isMobileSize()) {
                    videoDisplay = window.getComputedStyle(mobileVideoEl, null).display;
                    this.video = mobileVideoEl;
                    } else {
                    videoDisplay = window.getComputedStyle(desktopVideoEl, null).display;
                    this.video = desktopVideoEl;
                    }
                } else {
                    if (evt === 'touchstart') return;
                    videoDisplay = window.getComputedStyle(mobileVideoEl, null).display;
                    this.video = mobileVideoEl;
                }
                
                if (videoDisplay === 'flex' || videoDisplay === 'block') {
                    this.video.paused ? this.video.play() : this.video.pause();
                    this.isPlaying = !this.video.paused;
                    removeEventListener(evt, videoButton);
                }
                })
            }

            triggerEvents.forEach((evt) => setEvent(evt));
        },
        loadSvgIcon(svgUrl) {
            fetch(svgUrl)
                .then(response => {
                if (response.ok) {
                    return response.text();
                }
                throw new Error('Network response was not ok.');
                })
                .then(svgContent => {
                this.$el.innerHTML = svgContent;
                })
                .catch(error => {
                console.error('Error fetching SVG:', error);
                });
        },
        setVideosrc() {
            const sources = this.$el.querySelectorAll("source");

            sources.forEach((source) => {
                const src = source.dataset?.src;
                const type = source.dataset?.type;

                if (src) {
                    source.src = src;
                    source.type = type;
                    this.$el.load()
                }
            });
        }
    }))
})